// https://www.stefanjudis.com/snippets/turn-off-password-managers/
export const autoCompleteDisabledProperties = {
  autoComplete: "off",
  "data-lpignore": "true",
  "data-1p-ignore": "",
  "data-bwignore": "",
  "data-form-type": "other",
};
